import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpError } from './errors';
import { catchError } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SignlaterService {

  private stateUpdated = new Subject();
  public stateUpdated$ = this.stateUpdated.asObservable();

  private openSignLaterSource = new Subject<string>();
  public openSignLater$ = this.openSignLaterSource.asObservable();

  private setSignLaterSource = new Subject<string>();
  public setSignLaterSource$ = this.setSignLaterSource.asObservable();

  constructor(private http: HttpClient) {

  }

  public getSignLater(): any {
    var result = this.http.get<SignLater[]>('/docent/laterteondertekenen').pipe(catchError(error => {
      throw new HttpError(`Error retrieving later ondertekenen`);
    }));
    return result;
  }


  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() next: EventEmitter<boolean> = new EventEmitter();
  @Output() nextAfterSign: EventEmitter<boolean> = new EventEmitter();

  loadNext() {    
    this.next.emit();
  }

  loadNextAfterSign() {
    this.nextAfterSign.emit();
  }

  reload() : any {
    return this.change.emit();
  }  
}

export class SignLater {
  public studentnummer;
  public type;
  public creboCode;
  public id;
};



// WEBPACK FOOTER //
// ./src/app/signlater.service.ts